/*
 * mk-image-zoom.js — Module de zoom image PARTAGÉ (cart drawer + page cart /cart).
 * Une seule version. Contrôles PhotoSwipe IDENTIQUES à la galerie PDP
 * (theme.js registerLightboxUi_fn) : flèche prev (order 1) · X close (order 2) ·
 * flèche next (order 3), classes circle-button, mêmes icônes SVG, positionnés en
 * bas au centre par la CSS globale .pswp__top-bar (theme.css).
 *
 * Comportement : délégation de clic au niveau document sur [data-zoom-handle].
 * Au CLIC seulement → fetch('/products/{handle}.js') (mémoïsé) → PhotoSwipe
 * (lib importée à la demande via import-map global ; CSS .pswp déjà globale).
 * 1re image immédiate, reste en lazy. Zéro chargement tant qu'on ne clique pas.
 */
(function () {
  'use strict';
  if (window.MKImageZoom) return; // singleton : évite double-init si chargé 2 fois

  var _mediaCache = new Map();
  function fetchProductMedia(handle) {
    if (_mediaCache.has(handle)) return _mediaCache.get(handle);
    var p = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    _mediaCache.set(handle, p);
    return p;
  }

  async function openImageZoom(handle) {
    if (!handle) return;
    var product = await fetchProductMedia(handle);
    if (!product || !Array.isArray(product.media)) { window.location.href = '/products/' + handle; return; }
    var images = product.media.filter(function (m) { return m.media_type === 'image'; });
    if (!images.length) { window.location.href = '/products/' + handle; return; }
    var vw = Math.min(1200, Math.round((window.innerWidth || 1024) * (window.devicePixelRatio || 1)));
    var dataSource = images.map(function (m) {
      var pi = m.preview_image || m;
      var base = m.src || (pi && pi.src);
      var sized = base ? base + (base.indexOf('?') === -1 ? '?' : '&') + 'width=' + vw : base;
      return { src: sized, width: (pi && pi.width) || 1200, height: (pi && pi.height) || 1200, alt: product.title };
    });
    try {
      var mod = await import('photoswipe');
      var PhotoSwipe = mod.default || mod;
      var pswp = new PhotoSwipe({
        dataSource: dataSource, index: 0, bgOpacity: 0.92, showHideAnimationType: 'fade',
        arrowPrev: false, arrowNext: false, counter: false, close: false
      });
      pswp.on('uiRegister', function () {
        pswp.ui.registerElement({
          name: 'close-button',
          className: 'circle-button circle-button--xl hover:animate-icon-block',
          ariaLabel: 'Close', order: 2, isButton: true,
          html: '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"/></svg>',
          onClick: function () { pswp.close(); }
        });
        if (pswp.options.dataSource.length > 1) {
          pswp.ui.registerElement({
            name: 'previous-button',
            className: 'circle-button hover:animate-icon-inline',
            ariaLabel: 'Previous', order: 1, isButton: true,
            html: '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/></svg>',
            onClick: function () { pswp.prev(); }
          });
          pswp.ui.registerElement({
            name: 'next-button',
            className: 'circle-button hover:animate-icon-inline',
            ariaLabel: 'Next', order: 3, isButton: true,
            html: '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"/></svg>',
            onClick: function () { pswp.next(); }
          });
        }
      });
      pswp.init();
    } catch (err) {
      window.location.href = '/products/' + handle;
    }
  }

  // Délégation document-wide : marche pour le drawer, la page cart, et tout futur
  // élément portant data-zoom-handle.
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-zoom-handle]');
    if (!el) return;
    var handle = el.getAttribute('data-zoom-handle');
    if (!handle) return;
    e.preventDefault();
    openImageZoom(handle);
  });

  // Indicateurs sur les vignettes cliquables (style injecté une fois) :
  //  - DESKTOP : cursor:zoom-in (inchangé).
  //  - TACTILE (mobile) : badge loupe en coin bas-droit — MÊME SVG 'zoom' que la galerie PDP
  //    (snippets/icon.liquid, le when 'zoom' avec le "+"), encodé en data-URI pour la cohérence.
  //    Couvre automatiquement les 3 surfaces : .cart-item-img (drawer), .cart-page-img (page cart),
  //    .cart-xsell-img (up-sells) — via le CSS global, sans toucher au markup, survit aux re-renders.
  try {
    var st = document.createElement('style');
    st.textContent =
      '[data-zoom-handle]{position:relative;cursor:zoom-in}' +
      '@media (hover:none),(pointer:coarse){' +
        '[data-zoom-handle]{transition:transform .12s ease,opacity .12s ease}' +
        '[data-zoom-handle]::after{' +
          'content:"";position:absolute;right:4px;bottom:4px;width:18px;height:18px;' +
          'border-radius:50%;background-color:rgba(3,2,19,.6);' +
          'background-image:url("data:image/svg+xml,%3Csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%2014%2014%27%3E%3Cpath%20d=%27M9.432%209.432a4.94%204.94%200%201%201-6.985-6.985%204.94%204.94%200%200%201%206.985%206.985Zm0%200L13%2013%27%20fill=%27none%27%20stroke=%27%23fff%27%20stroke-linecap=%27square%27/%3E%3Cpath%20d=%27M6%203.5V6m0%202.5V6m0%200H3.5h5%27%20fill=%27none%27%20stroke=%27%23fff%27/%3E%3C/svg%3E");' +
          'background-repeat:no-repeat;background-position:center;background-size:11px 11px;' +
          'box-shadow:0 1px 3px rgba(0,0,0,.25);pointer-events:none;z-index:2;' +
        '}' +
        '[data-zoom-handle]:active{transform:scale(.97);opacity:.9}' +
      '}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}

  window.MKImageZoom = { open: openImageZoom };
})();
